var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35156 7.98437C3.35156 6.74605 4.35544 5.74217 5.59376 5.74217C6.83208 5.74217 7.83595 6.74605 7.83595 7.98437C7.83595 9.22269 6.83208 10.2266 5.59376 10.2266C4.35544 10.2266 3.35156 9.22269 3.35156 7.98437Z",
    stroke: "#2D3958",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85251 14.9062H2.09468C1.35287 14.9062 0.826198 14.1834 1.05334 13.4772C1.65674 11.6011 3.50606 10.2435 5.58272 10.2435C6.57336 10.2435 7.49181 10.5525 8.24705 11.0793",
    stroke: "#2D3958",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01172 4.24218C9.01172 3.00386 10.0156 1.99998 11.2539 1.99998C12.4922 1.99998 13.4961 3.00386 13.4961 4.24218C13.4961 5.4805 12.4922 6.48438 11.2539 6.48438C10.0156 6.48438 9.01172 5.4805 9.01172 4.24218Z",
    stroke: "#2D3958",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85547 7.96094C8.70545 7.06187 9.90935 6.50089 11.2443 6.50089C12.2349 6.50089 13.1533 6.80982 13.9086 7.3366",
    stroke: "#2D3958",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5664 14.1738V9.30424",
    stroke: "#2D3958",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 11.7393H10.1309",
    stroke: "#2D3958",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUsersIcon);
export default __webpack_public_path__ + "static/media/group-users-icon.e68198971db99bc4e571db9bb6a0d30e.svg";
export { ForwardRef as ReactComponent };